// API Base URL
// export const BASE_URL = "http://10.0.0.28:8080/api"; // Local development
export const BASE_URL = "https://api.goalflex.net/api"; // Production

// Handle all responses
const handleResponse = async (res) => {
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData?.error || "Something went wrong");
  }
  return res.json();
};

// Helper to get auth token from localStorage
const getAuthHeaders = () => {
  const user = localStorage.getItem("user");
  if (user) {
    try {
      const userData = JSON.parse(user);
      if (userData.token) {
        return { Authorization: `Bearer ${userData.token}` };
      }
    } catch (e) {
      // Invalid JSON in localStorage
    }
  }
  return {};
};

// GET request
export const get = async (path, headers = {}) => {
  const res = await fetch(`${BASE_URL}${path}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeaders(),
      ...headers,
    },
  });
  return handleResponse(res);
};

// POST request
export const post = async (path, body = {}, headers = {}) => {
  const res = await fetch(`${BASE_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeaders(),
      ...headers,
    },
    body: JSON.stringify(body),
  });
  return handleResponse(res);
};

// Unsubscribe user from email communications
export const unsubscribeUser = async (email, token, selectedOptions) => {
  return post("/unsubscribe", {
    email,
    token,
    preferences: selectedOptions,
  });
};

// Send message to backend
export const sendMessage = async (messageData) => {
  return post("/contact-messages", messageData);
};

// Login user with email and password
export const loginUser = async (email, password) => {
  return post("/login", { email, password });
};
